<template>
  <div class="logo-signature-videos-four-brands-content" id="identidade-visual-logo-assinatura-para-videos-ate-4-marcas" data-search-anchor>
    <div class="title-signature-videos-four-wrapper">
      <h1 class="logo-signature-videos-four-brands-title-span">
        {{ logoSignature4BrandsVideosTitleSpan }}
      </h1>
      <h1 class="logo-signature-videos-four-brands-title">{{ logoSignature4BrandsVideosTitle }}</h1>
    </div>

    <div class="logo-signature-videos-four-brands-video-player">
      <AutoPlayVideo :src="videoSrc" />
    </div>
    
    <div class="signature-videos-four-brands">
        <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar assinatura animada"          
        />      
    </div>  
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AutoPlayVideo from '@/components/AutoPlayVideo.vue'

@Component({
  components: {
    AutoPlayVideo
  }
})
export default class LogoSignature4BrandsVideosSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

   onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Assinatura%20Animada' 

  get logoSignature4BrandsVideosTitleSpan(): string {
    return this.getElementTitle(19, 0)
  }

  get logoSignature4BrandsVideosTitle(): string {
    return this.getElementText(19, 0)
  }

  @Ref('videoElement') readonly videoElement!: HTMLVideoElement
  @Ref('videoWrapper') readonly videoWrapper!: HTMLVideoElement

  get videoSrc(): string {
    return this.getElementMedia(19, 1)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-signature-videos-four-brands-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-signature-videos-four-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-signature-videos-four-brands-title-span { 
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-signature-videos-four-brands-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.signature-videos-four-brands {
  display: flex;
  align-items: center;   
  padding-top: 2rem;    
}
</style>
